
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Logo from '../assets/logoB.png';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const handleSignOut = () => {
    localStorage.clear();
    navigate('/login', { replace: true });
    setIsMenuOpen(false);
    setIsSubmenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isSubmenuOpen) setIsSubmenuOpen(false);
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };

  const closeMenus = () => {
    setIsMenuOpen(false);
    setIsSubmenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-brand">
        <NavLink to="/" className="brand-link" onClick={closeMenus}>
          <img src={Logo} alt="FugiPay Logo" className="header-logo-img" />
          <span>FugiPay</span>
        </NavLink>
      </div>

      <button className="hamburger" onClick={toggleMenu}>
        ☰
      </button>

      <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
            onClick={closeMenus}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
            onClick={closeMenus}
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
            onClick={closeMenus}
          >
            Contact
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/business"
            className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
            onClick={closeMenus}
          >
            Business
          </NavLink>
        </li>
        {user?.role === 'admin' && user?.kycStatus === 'verified' && user?.isActive ? (
          <li className="account-menu">
            <span className="nav-username" onClick={toggleSubmenu}>
              Hi, {user.username}
            </span>
            {isSubmenuOpen && (
              <ul className="submenu">
                <li>
                  <NavLink
                    to="/admin"
                    className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
                    onClick={closeMenus}
                  >
                    Admin Panel
                  </NavLink>
                </li>
                <li>
                  <button className="auth-button" onClick={handleSignOut}>
                    Sign Out
                  </button>
                </li>
              </ul>
            )}
          </li>
        ) : (
          <li>
            <NavLink
              to="/login"
              className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
              onClick={closeMenus}
            >
              Sign In
            </NavLink>
          </li>
        )}
      </ul>
    </header>
  );
};

export default Header;
